export const faqSchema = [
  {
    question: "What age group is Practido Learning Center designed for?",
    answer: "Practido offers programs for students aged 6 to 18 years with age-appropriate learning pathways and projects."
  },
  {
    question: "Do students need prior coding experience?",
    answer: "No. Most beginner programs require no prior coding or robotics knowledge. We start from the very basics."
  },
  {
    question: "What will students learn at Practido?",
    answer: "Students learn Artificial Intelligence, Robotics, Coding, STEM, Design Thinking, Video Editing and Future Skills through hands-on projects."
  },
  {
    question: "Are classes available online and offline?",
    answer: "Yes. Students can join online classes, offline center programs or hybrid options depending on their location."
  },
  {
    question: "Will students build real projects?",
    answer: "Yes. Every program includes practical projects that help students apply concepts and build confidence."
  },
  {
    question: "Can a 6-year-old learn coding?",
    answer: "Yes. Young learners start with Scratch, a visual tool that teaches logic and creativity through games and animations."
  },
  {
    question: "How do I enroll my child?",
    answer: "Book a free demo class from the Practido website. Our team will suggest the right course and plan. No payment is needed for the demo."
  }
];

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  "name": "Practido Learning Center",
  "url": "https://practido.com/ai-robotics-coding-classes-for-kids",
  "description": "Hands-on AI, Robotics, Coding and Future Skills programs for students aged 6–18.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Panipat",
    "addressRegion": "Haryana",
    "addressCountry": "IN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "availableLanguage": ["English", "Hindi"]
  }
};
